import React from 'react';

const ProductsMainMenu = ({ dateRangeComponent }) => {
  return (
    <div className='flex px-4 pr-8 items-center justify-between flex-col sm:flex-row gap-2 py-1'>
      <div className='order-0 sm:order-1 flex itesm-center gap-4 ml-auto'>
        <div className='sm:max-w-44'>{dateRangeComponent}</div>
      </div>
    </div>
  );
};
export default ProductsMainMenu;
